export const DLOCAL_ERROR_MESSAGES = {
  pan: 'El número de tarjeta es requerido.',
  expiration: 'La fecha de vencimiento es requerida.',
  cvv: 'El CVV es requerido.'
}
